import React, { useEffect, useState } from "react";
import BurgerMenu from "../../Component/BurgerMenu/BurgerMenu";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import MenuTop from "../../Component/MenuTop/MenuTop";
import Home from "../Home/Home";
const Landing = () => {
  const [MenuBurger, SetMenuBurger] = useState(false);


  const BurgerMenuOpenHandler = () => {
    SetMenuBurger(true);
  };
  const BurgerMenuCloseHandler = () => {
    SetMenuBurger(false);
  };
  return (
    <div>
      <MenuTop openMenu={BurgerMenuOpenHandler} />
      <Home />
      <BurgerMenu show={MenuBurger} CloseMenuHandler={BurgerMenuCloseHandler} />
      <MenuBottom />
    </div>
  );
};

export default Landing;
